import { getTgUserId } from "utils/tgWebApp"

/**
 * Telegram user IDs whitelisted for diagnostic telemetry.
 *
 * In production, only users in this set have diagnostics. In non-production
 * (local/dev/staging), diagnostics are enabled for everyone regardless of this set.
 *
 * Users in this set:
 * - Have Sentry initialized (with full Session Replay).
 * - See the floating "🐛 Send report" button.
 * - Trigger background diagnostic recording (memory, FPS, longtasks, etc.).
 *
 * To add a user: append their numeric Telegram ID and a comment with their username.
 * Source of ID: `window.Telegram.WebApp.initDataUnsafe.user.id`.
 */
export const DEBUG_USER_IDS: ReadonlySet<number> = new Set<number>([
  787382190, // @Yellow10041
  664219108 // @alexQA
  // 5134590895, // @tybik_1
  // 5150544780, // @tybik_2
  // 198944770, // @tybik_3
  // 532047531, // @tybik_4
  // 5718541561, // @tybik_5
  // 1096038244, // @tybik_6
  // 7424384955, // @tybik_7
  // 731228115, // @dimonuch93
  // 6942485396, // @Petrinko12
  // 666812729 // @tybik_8
])

/** True when the current Telegram user is in the diagnostic whitelist. */
export const isDebugUser = (): boolean => {
  const id = getTgUserId()
  return id !== undefined && DEBUG_USER_IDS.has(id)
}

/**
 * True when diagnostic telemetry (Sentry + DiagReportButton + recorder) should be enabled
 * for the current session.
 *
 * - In non-production environments: always enabled (for QA / dev convenience).
 * - In production: only enabled for users in `DEBUG_USER_IDS`.
 */
export const isDiagnosticsEnabled = (): boolean => {
  if (import.meta.env.VITE_NODE_ENV !== "production") return true
  return isDebugUser()
}
